const ProjectsIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M12 14.1949C11.824 14.1949 11.652 14.1489 11.5 14.0619L2.49996 8.86393C2.34795 8.77615 2.22172 8.64992 2.13396 8.4979C2.0462 8.34589 2 8.17345 2 7.99793C2 7.8224 2.0462 7.64996 2.13396 7.49795C2.22172 7.34593 2.34795 7.2197 2.49996 7.13193L11.5 1.93793C11.81 1.76093 12.19 1.76093 12.5 1.93793L21.5 7.13193C21.652 7.2197 21.7782 7.34593 21.8659 7.49795C21.9537 7.64996 21.9999 7.8224 21.9999 7.99793C21.9999 8.17345 21.9537 8.34589 21.8659 8.4979C21.7782 8.64992 21.652 8.77615 21.5 8.86393L12.5 14.0619C12.3478 14.1494 12.1754 14.1952 12 14.1949Z"
        fill="currentColor"
      />
      <path
        opacity="0.55"
        d="M21.5 11.132L19.536 9.99805L12.5 14.062C12.19 14.24 11.81 14.24 11.5 14.062L4.46396 9.99805L2.49996 11.132C2.34795 11.2198 2.22172 11.3461 2.13396 11.4981C2.0462 11.6501 2 11.8225 2 11.998C2 12.1736 2.0462 12.346 2.13396 12.498C2.22172 12.65 2.34795 12.7763 2.49996 12.864L11.5 18.062C11.81 18.24 12.19 18.24 12.5 18.062L21.5 12.864C21.652 12.7763 21.7782 12.65 21.8659 12.498C21.9537 12.346 21.9999 12.1736 21.9999 11.998C21.9999 11.8225 21.9537 11.6501 21.8659 11.4981C21.7782 11.3461 21.652 11.2198 21.5 11.132Z"
        fill="currentColor"
      />
      <path
        opacity="0.3"
        d="M21.5 15.132L19.536 13.998L12.5 18.062C12.19 18.24 11.81 18.24 11.5 18.062L4.46396 13.998L2.49996 15.132C2.34795 15.2198 2.22172 15.3461 2.13396 15.4981C2.0462 15.6501 2 15.8225 2 15.998C2 16.1736 2.0462 16.346 2.13396 16.498C2.22172 16.65 2.34795 16.7763 2.49996 16.864L11.5 22.062C11.81 22.24 12.19 22.24 12.5 18.062L21.5 16.864C21.652 16.7763 21.7782 16.65 21.8659 16.498C21.9537 16.346 21.9999 16.1736 21.9999 15.998C21.9999 15.8225 21.9537 15.6501 21.8659 15.4981C21.7782 15.3461 21.652 15.2198 21.5 15.132Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ProjectsIcon;
